import React from 'react';
import { Route, Switch } from 'react-router-dom';

import Dashboard from '../pages/Dashboard';

import Users from '../pages/Users';
import UsersInformation from './../pages/UsersInformation';

import Channels from './../pages/Channels';
import ChannelsInformation from './../pages/ChannelsInformation';
import ChannelsWithoutAddress from './../pages/ChannelsWithoutAddress';

import Activities from '../pages/Activities';

import ChallengeWinners from '../pages/ChallengeWinners';

import Issues from './../pages/Issues';
import IssuesInformation from './../pages/IssuesInformation';

import Shorts from '../pages/Shorts';
import ShortsInformation from '../pages/ShortsInformation/ShortsInformation';

import Payments from './../pages/Payments';
import PaymentsInformation from './../pages/PaymentsInformation';
import ChannelRecipients from '../components/Recipients';
import WithdrawRequests from './../pages/WithdrawRequests';
import DuplicatedTransactions from './../pages/DuplicatedTransactions';
import DuplicatedTransactionsList from '../pages/DuplicatedTransactionsList';

import Send from './../pages/Send';
import SendInformation from './../pages/SendInformation';

import AsyncTasks from './../pages/AsyncTasks';
import AsyncTasksInformation from '../pages/AsyncTasksInformation';

import Subscribers from '../pages/Subscribers/';
import SubscribersInformation from '../pages/SubscribersInformation';
import SubscriptionInformation from '../pages/SubscriptionInformation';
import DuplicatedsSubscribers from '../pages/DuplicatedsSubscribers';

import WebhookActions from '../pages/WebhookActions';
import WebhookActionsInformation from '../pages/WebhookActionsInformation';

import RecipientsInformation from '../pages/RecipientsInformation';

import BlackList from '../pages/BlackList';

import Tags from '../pages/Tags';
import TagIssues from '../pages/TagIssues';

import EmailStats from '../pages/EmailStats';

import Categories from './../pages/Categories';
import IssuesWithoutCategory from './../pages/IssuesWithoutCategory';

import Badges from './../pages/Badges';
import BadgeWinners from '../pages/BadgeWinners';

import Challenges from './../pages/Challenges';

import Ranking from './../pages/Rankings';

import AuthRequests from './../pages/AuthRequests';

import Recipients from '../pages/Recipients';

import LoopLinks from '../pages/LoopLinks';
import LoopLinksInformation from '../pages/LoopLinksInformation';

import Integrations from '../pages/Integrations';
import PaidSubscribes from '../pages/PaidSubscribes';
import PaidSubscribesInformation from '../pages/PaidSubscribesInformation';

import SaasPlans from '../pages/SaasPlans';
import SaasEducation from '../pages/SaasEducation';
import PaidSaas from '../pages/PaidSaas';

import EmailSends from '../pages/EmailSends';
import LandingPages from '../pages/LandingPages';

import CustomDomains from '../pages/CustomDomains';
import CustomDomainInformation from '../pages/CustomDomainInformation';

import SSLs from '../pages/SSLs';
import SSLInformation from '../pages/SSLInformation';

import CustomTemplate from '../pages/CustomTemplate';

import EmailTemplateStylesInformation from '../pages/EmailTemplateStylesInformation';

import CustomSender from '../pages/CustomSender';

import WarmupDomainsRules from '../pages/WarmupDomainsRules';
import ApiConnectKeys from '../pages/ApiConnectKeys';
import ShortLinkDomains from '../pages/ShortLinkDomains';
import BuyerClientsInGateway from '../pages/BuyerClientsInGateway';
import Invoices from '../pages/Invoices';

import Partners from '../pages/Partners';

import EducationList from '../pages/EducationList';

import EducationCourse from '../pages/EducationCourse';
import EducationSpecialClasses from '../pages/EducationSpecialClasses';
import EducationSpecialClass from '../pages/EducationSpecialClass';

import ContactBulkActions from '../pages/ContactBulkActions';

const Routes = () => {
  return (
    <Switch>
      <Route path="/users/searchItem=:searchItem&search=:search" component={Users} />
      <Route path="/users/:id" component={UsersInformation} />
      <Route path="/users" component={Users} />
      <Route path="/channels/withoutAddress" component={ChannelsWithoutAddress} />
      <Route path="/channels/searchItem=:searchItem&search=:search" component={Channels} />
      <Route path="/channels/:uid" component={ChannelsInformation} />
      <Route path="/channels" component={Channels} />
      <Route path="/issues/searchItem=:searchItem&search=:search" component={Issues} />
      <Route path="/issues/:uid" component={IssuesInformation} />
      <Route path="/issues" component={Issues} />
      <Route path="/withdrawRequests" component={WithdrawRequests} />
      <Route path="/transactions/searchItem=:searchItem&search=:search" component={Payments} />
      <Route path="/transactions/duplicated/:transactionIdInOrigin/:paymentToken" component={DuplicatedTransactionsList} />
      <Route path="/transactions/duplicated" component={DuplicatedTransactions} />
      <Route path="/transactions/:uid" component={PaymentsInformation} />
      <Route path="/transactions" component={Payments} />
      <Route path="/sends/searchItem=:searchItem&search=:search" component={Send} />
      <Route path="/sends/:id" component={SendInformation} />
      <Route path="/sends" component={Send} />
      <Route path="/asynctasks/searchItem=:searchItem&search=:search" component={AsyncTasks} />
      <Route path="/asynctasks/:id" component={AsyncTasksInformation} />
      <Route path="/asynctasks" component={AsyncTasks} />
      <Route path="/subscribers/duplicated" component={DuplicatedsSubscribers} />
      <Route path="/subscribers/searchItem=:searchItem&search=:search" component={Subscribers} />
      <Route path="/subscribers/:uid" component={SubscribersInformation} />
      <Route path="/subscription/:uid" component={SubscriptionInformation} />
      <Route path="/subscribers" component={Subscribers} />
      <Route path="/tag/:slug" component={TagIssues} />
      <Route path="/tags" component={Tags} />
      <Route path="/badgeWinners/:uid" component={BadgeWinners} />
      <Route path="/badges" component={Badges} />
      <Route path="/challengeWinners/:uid" component={ChallengeWinners} />
      <Route path="/challenges" component={Challenges} />
      <Route path="/rankings" component={Ranking} />
      <Route path="/authRequests" component={AuthRequests} />
      {/* <Route path="/ranking" component={ChannelRank} /> */}
      <Route path="/email" component={EmailStats} />
      <Route path="/issuesWithoutCategory" component={IssuesWithoutCategory} />
      <Route path="/categories" component={Categories} />
      <Route path="/recipients/search=:search&searchItem=:searchItem" component={ChannelRecipients} />
      <Route path="/recipients/:id" component={RecipientsInformation} />
      <Route path="/webhooks/searchItem=:searchItem&search=:search" component={WebhookActions} />
      <Route path="/webhooks/:uniqueId" component={WebhookActionsInformation} />
      <Route path="/webhooks" component={WebhookActions} />
      <Route path="/blackList" component={BlackList} />
      <Route path="/recipients" component={Recipients} />
      <Route path="/shorts/searchItem=:searchItem&search=:search" component={Shorts} />
      <Route path="/shorts/:id" component={ShortsInformation} />
      <Route path="/shorts" component={Shorts} />
      <Route path="/loops/:id" component={LoopLinksInformation} />
      <Route path="/loops" component={LoopLinks} />
      <Route path="/" exact component={Users} />
      <Route path="/integrations" component={Integrations} />
      <Route path="/activities" component={Activities} />
      <Route path="/paid-subscribes/:id" component={PaidSubscribesInformation} />
      <Route path="/paid-subscribes" component={PaidSubscribes} />
      <Route path="/saasPlans" component={SaasPlans} />
      <Route path="/paidSaas" component={PaidSaas} />
      <Route path="/emailSends" component={EmailSends} />
      <Route path="/invoices" component={Invoices} />
      <Route path="/landingPages" component={LandingPages} />
      <Route path="/custom-domains/:id" component={CustomDomainInformation} />
      <Route path="/custom-domains" component={CustomDomains} />
      <Route path="/ssl/:id" component={SSLInformation} />
      <Route path="/ssl" component={SSLs} />
      <Route path="/custom-template" component={CustomTemplate} />
      <Route path="/saas-education" component={SaasEducation} />
      <Route path="/email-template-styles/:id" component={EmailTemplateStylesInformation} />
      <Route path="/custom-senders" component={CustomSender} />
      <Route path="/contact-bulk-actions" component={ContactBulkActions} />
      <Route path="/warmup-domains-rules" component={WarmupDomainsRules} />
      <Route path="/api-connect-keys" component={ApiConnectKeys} />
      <Route path="/short-link-domains" component={ShortLinkDomains} />
      <Route path="/stripe-sync-buyers/searchItem=:searchItem&search=:search" component={BuyerClientsInGateway} />
      <Route path="/stripe-sync-buyers" component={BuyerClientsInGateway} />
      <Route path="/partners" component={Partners} />
      <Route path="/education/course/:id" component={EducationCourse} />
      <Route path="/education/course" component={EducationCourse} />
      <Route path="/education" component={EducationList} />
      <Route path="/unique-lessons/course/:id" component={EducationSpecialClass} />
      <Route path="/unique-lessons/course" component={EducationSpecialClass} />
      <Route path="/unique-lessons" component={EducationSpecialClasses} />
    </Switch>
  );
};

export default Routes;
